import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch } from '../../redux';
import { fetchPracticeLeads } from '../../redux/practice/practiceSlice';
import { RootState } from '../../redux';
import { useCallback, useEffect } from 'react';

export const useFetchPracticeLeads = (practiceId: string) => {
  const dispatch = useDispatch<AppDispatch>();
  const { leads, isLoading, error } = useSelector((state: RootState) => state.practices);
  
  // Get practiceId from localStorage if not provided
  const getPracticeId = useCallback(() => {
    if (practiceId) return practiceId;
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    return user?.["custom:id_practice"] || user?.practice_id || null;
  }, [practiceId]);

  const fetchPracticeLeadsData = useCallback((id?: string) => {
    const pid = id || getPracticeId();
    if (pid) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      dispatch(fetchPracticeLeads(pid) as any);
    }
  }, [dispatch, getPracticeId]);

  // Automatically fetch leads when component mounts
  useEffect(() => {
    const pid = getPracticeId();
    if (pid) {
      fetchPracticeLeadsData(pid);
    }
  }, [fetchPracticeLeadsData, getPracticeId]);

  return { leads, isLoading, error, fetchPracticeLeadsData };
}